import { peopleApi as api } from './peopleApi';
export const addTagTypes = [
  'People',
  'FriendTypes',
  'PeopleAssets',
  'RelationshipTypes'
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      addPeople: build.mutation<AddPeopleApiResponse, AddPeopleApiArg>({
        query: queryArg => ({
          url: `/people`,
          method: 'POST',
          body: queryArg.createPeople
        }),
        invalidatesTags: ['People']
      }),
      getFriendType: build.query<GetFriendTypeApiResponse, GetFriendTypeApiArg>(
        {
          query: queryArg => ({
            url: `/friendType`,
            params: {
              search: queryArg.search,
              offset: queryArg.offset,
              limit: queryArg.limit,
              sortby: queryArg.sortby,
              orderby: queryArg.orderby,
              userId: queryArg.userId
            }
          }),
          providesTags: ['FriendTypes']
        }
      ),
      addFriendType: build.mutation<
        AddFriendTypeApiResponse,
        AddFriendTypeApiArg
      >({
        query: queryArg => ({
          url: `/friendType`,
          method: 'POST',
          body: queryArg.createFriendType
        }),
        invalidatesTags: ['FriendTypes']
      }),
      getPeople: build.mutation<GetPeopleApiResponse, GetPeopleApiArg>({
        query: queryArg => ({
          url: `/people/search`,
          method: 'POST',
          body: queryArg.peopleSearch
        }),
        invalidatesTags: ['People']
      }),
      getPeopleBySubscriber: build.query<
        GetPeopleBySubscriberApiResponse,
        GetPeopleBySubscriberApiArg
      >({
        query: queryArg => ({
          url: `/people/subscriber/list`,
          params: {
            subscriberId: queryArg.subscriberId,
            referenceId: queryArg.referenceId,
            sortBy: queryArg.sortBy,
            orderBy: queryArg.orderBy,
            search: queryArg.search,
            module: queryArg['module']
          }
        }),
        providesTags: ['People']
      }),
      getPeopleByName: build.query<
        GetPeopleByNameApiResponse,
        GetPeopleByNameApiArg
      >({
        query: queryArg => ({
          url: `/peopleByName`,
          params: {
            search: queryArg.search,
            module: queryArg['module'],
            type: queryArg['type'],
            peopleId: queryArg.peopleId,
            momentId: queryArg.momentId,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            userFolderId: queryArg.userFolderId,
            isInsidePeople: queryArg.isInsidePeople,
            isSharedWithMe: queryArg.isSharedWithMe,
            isMyFiles: queryArg.isMyFiles,
            access: queryArg.access,
            groupId: queryArg.groupId
          }
        }),
        providesTags: ['People']
      }),
      getBasicPeopleList: build.query<
        GetBasicPeopleListApiResponse,
        GetBasicPeopleListApiArg
      >({
        query: queryArg => ({
          url: `/basicPeopleList`,
          params: {
            search: queryArg.search,
            type: queryArg['type'],
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby
          }
        }),
        providesTags: ['People']
      }),
      getBasicPeopleInfoById: build.query<
        GetBasicPeopleInfoByIdApiResponse,
        GetBasicPeopleInfoByIdApiArg
      >({
        query: queryArg => ({ url: `/people-basic/${queryArg.id}` }),
        providesTags: ['People']
      }),
      getPeopleById: build.query<GetPeopleByIdApiResponse, GetPeopleByIdApiArg>(
        {
          query: queryArg => ({ url: `/people/${queryArg.id}` }),
          providesTags: ['People']
        }
      ),
      updatePeople: build.mutation<UpdatePeopleApiResponse, UpdatePeopleApiArg>(
        {
          query: queryArg => ({
            url: `/people/${queryArg.id}`,
            method: 'PUT',
            body: queryArg.updatePeople
          }),
          invalidatesTags: ['People']
        }
      ),
      deletePeople: build.mutation<DeletePeopleApiResponse, DeletePeopleApiArg>(
        {
          query: queryArg => ({
            url: `/people/${queryArg.id}`,
            method: 'DELETE',
            params: { delete: queryArg['delete'] }
          }),
          invalidatesTags: ['People']
        }
      ),
      createPeopleFromGedcom: build.mutation<
        CreatePeopleFromGedcomApiResponse,
        CreatePeopleFromGedcomApiArg
      >({
        query: queryArg => ({
          url: `/create-people-from-gedcom`,
          method: 'POST',
          body: queryArg.createPeopleFromGedcom
        }),
        invalidatesTags: ['People']
      }),
      deletePeopleFromTree: build.mutation<
        DeletePeopleFromTreeApiResponse,
        DeletePeopleFromTreeApiArg
      >({
        query: queryArg => ({
          url: `/peopleFromTree/${queryArg.id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['People']
      }),
      bulkDeletePeople: build.mutation<
        BulkDeletePeopleApiResponse,
        BulkDeletePeopleApiArg
      >({
        query: queryArg => ({
          url: `/people/bulk-delete`,
          method: 'POST',
          body: queryArg.bulkDeletePeople
        }),
        invalidatesTags: ['People']
      }),
      bulkPrivatePeople: build.mutation<
        BulkPrivatePeopleApiResponse,
        BulkPrivatePeopleApiArg
      >({
        query: queryArg => ({
          url: `/people/bulk-private`,
          method: 'POST',
          body: queryArg.bulkPrivatePeople
        }),
        invalidatesTags: ['People']
      }),
      peopleEdit: build.mutation<PeopleEditApiResponse, PeopleEditApiArg>({
        query: queryArg => ({
          url: `/peopleEdit`,
          method: 'POST',
          body: queryArg.updatedPeople
        }),
        invalidatesTags: ['People']
      }),
      createPersonWithSync: build.mutation<
        CreatePersonWithSyncApiResponse,
        CreatePersonWithSyncApiArg
      >({
        query: queryArg => ({
          url: `/people/create`,
          method: 'POST',
          body: queryArg.createPeople
        }),
        invalidatesTags: ['People']
      }),
      updatePersonWithSync: build.mutation<
        UpdatePersonWithSyncApiResponse,
        UpdatePersonWithSyncApiArg
      >({
        query: queryArg => ({
          url: `/people/update/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updatePeople
        }),
        invalidatesTags: ['People']
      }),
      mergePeople: build.mutation<MergePeopleApiResponse, MergePeopleApiArg>({
        query: queryArg => ({
          url: `/people/merge`,
          method: 'POST',
          body: queryArg.mergePeople
        }),
        invalidatesTags: ['People']
      }),
      gedcomMapping: build.mutation<
        GedcomMappingApiResponse,
        GedcomMappingApiArg
      >({
        query: queryArg => ({
          url: `/people/gedcomMapping`,
          method: 'POST',
          body: queryArg.gedcomMappingParams
        }),
        invalidatesTags: ['People']
      }),
      exportFamilyTree: build.mutation<
        ExportFamilyTreeApiResponse,
        ExportFamilyTreeApiArg
      >({
        query: queryArg => ({
          url: `/exportFamilyTree`,
          method: 'POST',
          body: queryArg.exportFamilyTreeParams,
          responseHandler: async (response: Response) => {
            const disposition =
              response.headers.get('Content-Disposition') || '';
            const match = disposition.match(
              /filename[^;=\n]*=(['"]?)([^;\n"']+)\1/
            );
            const fileName = match?.[2]?.trim() || 'family_tree.gedcom';
            const blob = await response.blob();
            return { blob, fileName };
          }
        })
      }),
      addPeopleAsset: build.mutation<
        AddPeopleAssetApiResponse,
        AddPeopleAssetApiArg
      >({
        query: queryArg => ({
          url: `/peopleAsset`,
          method: 'POST',
          body: queryArg.createPeopleAsset
        }),
        invalidatesTags: ['PeopleAssets']
      }),
      getRelationshipTypes: build.query<
        GetRelationshipTypesApiResponse,
        GetRelationshipTypesApiArg
      >({
        query: queryArg => ({
          url: `/relationshipTypes`,
          params: {
            search: queryArg.search,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby
          }
        }),
        providesTags: ['RelationshipTypes']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type AddPeopleApiResponse =
  /** status 201 Person has been created successfully. */ {
    ok?: boolean;
    data?: PeopleWithCount;
    message?: string;
  };
export type AddPeopleApiArg = {
  /** Person data to be added */
  createPeople: CreatePeople;
};
export type GetFriendTypeApiResponse = /** status 200 FriendTypes found. */ {
  ok?: boolean;
  data?: FriendType;
  message?: string;
};
export type GetFriendTypeApiArg = {
  /** Search text */
  search?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** userId */
  userId?: string;
};
export type AddFriendTypeApiResponse =
  /** status 201 FriendType has been created successfully. */ {
    ok?: boolean;
    data?: FriendType;
    message?: string;
  };
export type AddFriendTypeApiArg = {
  /** FriendType that needs to be added to the application */
  createFriendType: CreateFriendType;
};
export type GetPeopleApiResponse = /** status 200 People found. */ {
  ok?: boolean;
  data?: People;
  message?: string;
};
export type GetPeopleApiArg = {
  /** Filter parameters for searching people */
  peopleSearch: PeopleSearch;
};
export type GetPeopleBySubscriberApiResponse = {
  data: PeopleBySubscriber;
};
export type GetPeopleBySubscriberApiArg = {
  /** Subscriber ID */
  subscriberId?: string;
  /** Reference ID */
  referenceId?: string;
  /** Field to sort by */
  sortBy?: string;
  /** Sort order */
  orderBy?: 'ASC' | 'DESC';
  /** Search by name */
  search?: string;
  /** Module to filter by */
  module?: string;
};
export type GetPeopleByNameApiResponse = /** status 200 People found. */ {
  ok?: boolean;
  data?: People;
  message?: string;
};
export type GetPeopleByNameApiArg = {
  /** Search text */
  search?: string;
  /** Module to filter by */
  module?: string;
  /** Search text */
  type?: string;
  /** ID of people */
  peopleId?: string;
  /** ID of moment */
  momentId?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;

  userFolderId?: string;
  isInsidePeople?: boolean;
  isSharedWithMe?: boolean;
  isMyFiles?: boolean;
  access?: string;
  groupId?: string;
};
export type GetBasicPeopleListApiResponse = /** status 200 People found. */ {
  ok?: boolean;
  data?: BasicPeopleInfoList;
  message?: string;
};
export type GetBasicPeopleListApiArg = {
  /** Search text */
  search?: string;
  /** Search text */
  type?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
};
export type GetBasicPeopleInfoByIdApiResponse =
  /** status 200 People details found. */ {
    ok?: boolean;
    data?: BasicPeopleInfo;
    message?: string;
  };
export type GetBasicPeopleInfoByIdApiArg = {
  /** ID of the People to retrieve */
  id: string;
};
export type GetPeopleByIdApiResponse = /** status 200 People details found. */ {
  ok?: boolean;
  data?: PeopleWithCount;
  message?: string;
};
export type GetPeopleByIdApiArg = {
  /** ID of the People to retrieve */
  id: string;
};
export type UpdatePeopleApiResponse =
  /** status 200 The person's details have been updated successfully */ {
    ok?: boolean;
    data?: {
      success?: boolean;
    };
    message?: string;
  };
export type UpdatePeopleApiArg = {
  /** ID of the People to update */
  id: string;
  /** Person data to be updated */
  updatePeople: UpdatePeople;
};
export type DeletePeopleApiResponse =
  /** status 200 The People's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeletePeopleApiArg = {
  /** ID of the People to delete */
  id: string;
  /** flag to hard delete */
  delete?: string;
};
export type CreatePeopleFromGedcomApiResponse =
  /** status 201 People have been created successfully from GEDCOM. */ {
    ok?: boolean;
    data?: CreatePeopleFromGedcomResponse;
    message?: string;
  };
export type CreatePeopleFromGedcomApiArg = {
  /** Data parsed from GEDCOM file to create people in bulk */
  createPeopleFromGedcom: CreatePeopleFromGedcom;
};
export type DeletePeopleFromTreeApiResponse =
  /** status 200 The People's details has been deleted from the tree successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeletePeopleFromTreeApiArg = {
  /** ID of the People to delete */
  id: string;
};
export type BulkDeletePeopleApiResponse =
  /** status 200 People deleted successfully. */ {
    ok?: boolean;
    data?: BulkDeletePeopleResponse;
    message?: string;
  };
export type BulkDeletePeopleApiArg = {
  /** Array of people IDs to delete and delete type */
  bulkDeletePeople: BulkDeletePeople;
};
export type BulkPrivatePeopleApiResponse =
  /** status 200 People privacy updated successfully. */ {
    ok?: boolean;
    data?: BulkPrivatePeopleResponse;
    message?: string;
  };
export type BulkPrivatePeopleApiArg = {
  /** Array of people IDs and privacy status */
  bulkPrivatePeople: BulkPrivatePeople;
};
export type PeopleEditApiResponse =
  /** status 201 Person has been created successfully. */ {
    ok?: boolean;
    data?: PeopleWithCount;
    message?: string;
  };
export type PeopleEditApiArg = {
  /** Person data to be added */
  updatedPeople: UpdatedPeople;
};
export type CreatePersonWithSyncApiResponse =
  /** status 201 Person created successfully in PostgreSQL and Neptune graph database. */ {
    ok?: boolean;
    data?: PeopleWithCount;
    message?: string;
  };
export type CreatePersonWithSyncApiArg = {
  /** Person data to create in both databases */
  createPeople: CreatePeople;
};
export type UpdatePersonWithSyncApiResponse =
  /** status 200 Person updated successfully in PostgreSQL and Neptune graph database. */ {
    ok?: boolean;
    data?: PeopleWithCount;
    message?: string;
  };
export type UpdatePersonWithSyncApiArg = {
  /** ID of the person to update */
  id: string;
  /** Person data to update in both databases */
  updatePeople: UpdatePeople;
};
export type MergePeopleApiResponse =
  /** status 200 People merged successfully */ {
    type?: string;
    properties?: {
      ok?: {
        type?: string;
        example?: boolean;
      };
      data?: {
        type?: string;
        properties?: {
          success?: {
            type?: string;
            example?: boolean;
          };
          message?: {
            type?: string;
            example?: string;
          };
          sourcePersonId?: {
            type?: string;
            example?: string;
          };
          targetPersonId?: {
            type?: string;
            example?: string;
          };
          mergedInto?: {
            type?: string;
            properties?: {
              id?: {
                type?: string;
              };
              name?: {
                type?: string;
              };
              userId?: {
                type?: string;
              };
            };
          };
          stats?: {
            type?: string;
            properties?: {
              faceDetectionsMerged?: {
                type?: string;
                example?: number;
              };
              assetsMerged?: {
                type?: string;
                example?: number;
              };
              relationshipsMerged?: {
                type?: string;
                example?: number;
              };
              faceMappingsMerged?: {
                type?: string;
                example?: number;
              };
              diariesMerged?: {
                type?: string;
                example?: number;
              };
            };
          };
        };
      };
      message?: {
        type?: string;
        example?: string;
      };
    };
  };
export type MergePeopleApiArg = {
  /** Person data to create in both databases */
  mergePeople: MergePeople;
};
export type GedcomMappingApiResponse =
  /** status 200 The person's details have been updated successfully */ {
    ok?: boolean;
    data?: GedcomMappingResponse;
    message?: string;
  };
export type GedcomMappingApiArg = {
  /** Data to get the GEDCOM mapping */
  gedcomMappingParams: GedcomMappingParams;
};
export type ExportFamilyTreeApiResponse = { blob: Blob; fileName: string };
export type ExportFamilyTreeApiArg = {
  /** Data to export the family tree */
  exportFamilyTreeParams: ExportFamilyTreeParams;
};
export type AddPeopleAssetApiResponse =
  /** status 201 PeopleAsset has been created successfully. */ {
    ok?: boolean;
    data?: PeopleAsset;
    message?: string;
  };
export type AddPeopleAssetApiArg = {
  /** PeopleAsset that needs to be added to the application */
  createPeopleAsset: CreatePeopleAsset;
};
export type GetRelationshipTypesApiResponse =
  /** status 200 RelationshipTypes found. */ {
    ok?: boolean;
    data?: RelationshipTypes;
    message?: string;
  };
export type GetRelationshipTypesApiArg = {
  /** Search text */
  search?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
};
export type PeopleWithCount = {
  id?: string;
  userId?: string;
  subscriberId?: string;
  name?: string;
  nickname?: string;
  hasOwnerAccess?: boolean;
  email?: string;
  isEmailEditable?: boolean;
  gender?: string;
  dateOfBirth?: string;
  birthPlace?: string;
  profileImage?: string;
  awsRecognitionId?: string;
  type?: string;
  relationShipWith?: string;
  relationShip?: string;
  status?: string;
  isPrivate?: boolean;
  photoCount?: number;
  createdAt?: string;
  updatedAt?: string;
  members?: {
    name?: string;
    relationShip?: string;
    id?: string;
  }[];
  isFather?: number;
  isMother?: number;
  relationships?: {
    id?: string;
    isMainPerson?: boolean;
    relatedPerson: {
      id?: string;
      name?: string;
      nickname?: string;
      profileImage?: string;
      type?: string;
    };
    relationshipType: string;
  }[];
};
export type CreatePeople = {
  peopleId?: string;
  email?: string;
  userId?: string;
  subscriberId?: string;
  name: string;
  nickname?: string;
  gender?: string;
  dateOfBirth?: string;
  birthPlace?: string;
  profileImage?: string;
  awsRecognitionId?: string;
  type?: string;
  livingStatus?: string;
  relationshipType?: string;
  relationShipWith?: string;
  familyMembers?: {
    name?: string;
    relation?: string;
    relationshipTypeId?: number;
    id?: string;
    dateOfBirth?: string;
    deathDate?: string;
    currentStatus?: string;
    gender?: string;
    profileImage?: string;
    tempId?: string;
  }[];
  relations?: {
    to?: string;
    from?: string;
    relation?: string | number;
    relationshipTypeId?: number;
  }[];
  relationShip?: number;
  deathDate?: string;
  friendType?: string;
  relatedPeopleId?: string;
  mutualFriends?: {
    name?: string;
    id?: string;
  }[];
};
export type FriendType = {
  count?: number;
  rows?: {
    name: string;
    subscriberId: string;
    createdAt: string;
    updatedAt: string;
  }[];
};
export type CreateFriendType = {
  name: string;
  subscriberId?: string;
};
export type People = {
  count?: number;
  rows?: {
    id: string;
    name?: string;
    userId?: string;
    type?: string;
    fullName?: string;
    email?: string;
    profileImage?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: any;
    dateOfBirth?: any;
    gender?: any;
    maxConfidence?: number;
    isVerified?: boolean;
    detectionCount?: number;
    asset_count?: number;
    moment_count?: number;
    peopleId?: string;
  }[];
};
export type PeopleSearch = {
  search?: string;
  offset?: number;
  limit?: number;
  sortby?: string;
  orderby?: string;
  people?: any[];
  things?: any[];
  locations?: any[];
  dates?: any[];
  mediaType?: any[];
  type?: string;
};
export type PeopleBySubscriber = {
  subscriptionOwnerId?: string;
  people: {
    id?: string;
    label?: string;
    subscriberId?: string;
    name?: string;
    profileImage?: string;
    dateOfBirth?: string;
    status?: string;
    isMaster?: boolean;
    isOwner?: boolean;
    hasNonBloodRelations?: boolean;
  }[];
  relationships?: {
    from?: string;
    relationship?: string;
    to?: string;
  }[];
};
export type BasicPeopleInfoList = {
  count: number;
  rows: {
    id?: string;
    name?: string;
    profileImage?: string;
  }[];
};
export type BasicPeopleInfo = {
  id: string;
  name: string;
  nickname?: string;
  email?: string;
  gender: string;
  dateOfBirth?: string;
  birthPlace?: string;
  profileImage?: string;
  deathDate?: string;
  status?: string;
};
export type UpdatePeople = {
  name?: string;
  nickname?: string;
  email?: string;
  gender?: string;
  dateOfBirth?: string;
  birthPlace?: string;
  deathDate?: string;
  profileImage?: string;
  type?: string;
  relationShipWith?: string;
  relationShip?: string;
  status?: string;
  livingStatus?: string;
  userId?: string;
  subscriberId?: string;
  familyMembers?: any[];
};
export type CreatePeopleFromGedcomResponse = {
  message?: string;
  success?: {
    uuid?: string;
    name?: string;
  }[];
  errors?: {
    uuid?: string;
    name?: string;
    error?: string;
  }[];
};
export type CreatePeopleFromGedcom = {
  people?: {
    birthPlace?: string;
    dateOfBirth?: string;
    deathDate?: string;
    gender?: string | null;
    name?: string;
    isPlaceholder?: boolean;
    profileImage?: string;
    nickname?: string;
    peopleId?: string;
    type?: string;
    gedcomId?: string;
  }[];
  relations?: {
    from?: string;
    to?: string;
    relationShip?: string;
  }[];
};
export type BulkDeletePeopleResponse = {
  success?: boolean;
  deletedCount?: number;
};
export type BulkDeletePeople = {
  peopleIds?: string[];
  isDelete?: boolean;
  isTreeOnly?: boolean;
};
export type BulkPrivatePeopleResponse = {
  success?: boolean;
  updatedCount?: number;
};
export type BulkPrivatePeople = {
  peopleIds?: string[];
  isPrivate?: boolean;
};
export type UpdatedPeople = {
  ownerId?: string;
  type?: string;
  familyMembers?: {
    name?: string;
    relationShip?: string;
    id?: string;
  }[];
  mutualFriends?: {
    name?: string;
    id?: string;
  }[];
  delete?: string[];
};
export type MergePeople = {
  sourcePersonId?: string;
  targetPersonId?: string;
  deleteSource?: boolean;
};
export type GedcomMappingResponse = Record<string, string>;
export type GedcomMappingParams = {
  gedcomPeople?: {
    id?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    gender?: string;
    familyAsSpouse?: string[];
    familyAsChild?: string;
    allFamiliesAsChild?: string[];
    familyAsChildPedigrees?: {
      F8?: string;
    };
  }[];
  gedcomRelations?: {
    sourceId?: string;
    targetId?: string;
    relationType?: string;
  }[];
};
export type ExportFamilyTreeParams = {
  fileName?: string;
  sourceName?: string;
  exportOptions?: {
    includePlaceholders?: boolean;
    includeProfileImageNote?: boolean;
    includeSiblingOnlyFamilies?: boolean;
  };
};
export type PeopleAsset = {
  count?: number;
  rows?: {
    id: string;
    peopleId: string;
    assetId: string;
    status: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  }[];
};
export type CreatePeopleAsset = {
  assetId: string;
  peopleId: string[];
  removeOld: boolean;
};
export type RelationshipTypes = {
  count?: number;
  rows?: {
    id: string;
    name: string;
    targetGender?: string;
    canonicalCode?: string;
    path?: string[];
    relationType?: string;
  }[];
};
export const {
  useAddPeopleMutation,
  useGetFriendTypeQuery,
  useAddFriendTypeMutation,
  useGetPeopleMutation,
  useGetPeopleBySubscriberQuery,
  useGetPeopleByNameQuery,
  useGetBasicPeopleListQuery,
  useGetBasicPeopleInfoByIdQuery,
  useGetPeopleByIdQuery,
  useUpdatePeopleMutation,
  useDeletePeopleMutation,
  useCreatePeopleFromGedcomMutation,
  useDeletePeopleFromTreeMutation,
  useBulkDeletePeopleMutation,
  useBulkPrivatePeopleMutation,
  usePeopleEditMutation,
  useCreatePersonWithSyncMutation,
  useUpdatePersonWithSyncMutation,
  useMergePeopleMutation,
  useGedcomMappingMutation,
  useExportFamilyTreeMutation,
  useAddPeopleAssetMutation,
  useGetRelationshipTypesQuery
} = injectedRtkApi;
